import React from "react";

export default function FullScreenVideo(post) {
  
  const {
    obj
  } = post;
  
    return (
      <div className={obj.fieldGroupName}>
        <div className="videoContainer">
        <span className="imgreveal"></span>
        <video muted="true" loop="true" autoplay="autoplay" role="application" preload="auto" id="vid" playsinline="true">
          <source src={obj.video.mediaItemUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
          <div className="textOverImage">
            <h3 className="small">{obj.optionalHeading}</h3>
            <hr />
            <div dangerouslySetInnerHTML={{__html: obj.optionalContent}}></div>
          </div>
        </div>
      </div>
    );
  }  